import React, { Suspense,lazy } from 'react';
import { Route, Switch } from 'react-router';
import ErrorBoundary  from '../ErrorBoundary';

const isProductionEnvironment = window.location.host === "www.verizon.com" || window.location.host === "espanol.verizon.com"
const segment = lazy(() => import('../containers/push/segment'));
const campaign = lazy(() => import('../containers/push/campaign'));
const loopQual = lazy(() => import("../containers/addressQualification/index"));
const loopQualWidget = lazy(() => import("../containers/addressQualification/loopQualWidget"));
const smartSave = lazy(() => import("../containers/addressQualification/smartSave"));
const smartSaveEmail = lazy(() => import("../containers/addressQualification/smartSaveEmail"));
const pendingOrder = lazy(() => import("../containers/addressQualification/pendingOrder"));
const nonfiosRedirect = lazy(()=> import("../containers/addressQualification/nonfiosRedirect"))
const mfrtVendor = lazy(() => import("../containers/addressQualification/mfrtVendor"));
const signInMH = lazy(() => import('../containers/addressQualification/signInMH'));
const fifteng = lazy(() => import("../containers/addressQualification/fifteng"));
const buildProduct = lazy(() => import("../containers/buildProduct/index"));
const popularPlans = lazy(() => import("../containers/popularPlans/index"));
const buildProductReskin = lazy(() => import(/* webpackChunkName: "buildProduct" */ "../containers/buildProduct/indexRskn"));
const streamlineOrdering = lazy(() => import(/* webpackChunkName: "streamlineOrdering" */ "../containers/streamlineOrdering/index"));
const streamlineTVPhoneOrdering = lazy(() => import("../containers/streamlineOrdering/tvVoice"));
const help = lazy(() => import("../containers/addressQualification/help"));
const signIn = lazy(() => import("../containers/addressQualification/signIn"));
const signInCoupon = lazy(() => import("../containers/addressQualification/signInCoupon"));
const checkout = lazy(() => import("../containers/checkout/index"));
const lbo = lazy(() => import("../containers/lbo/index"));
const custError = lazy(() => import("../containers/lbo/custError"));
const submitOrder = lazy(() => import("../containers/submitOrder"));
const futureNotification = lazy(() => import("../containers/addressQualification/futureNotificationPage"));
const moveLanding = lazy(() => import("../containers/move/index"));
const moveLandingReskin = lazy(() => import("../containers/move/indexRskn"));
const tileComp = lazy(() => import("../containers/samplePage/tileComp"));
const nsiNotification = lazy(() => import("../containers/nsiNotify/index"));
const nsiNYC = lazy(()=>import("../containers/nsiNotify/nsiNYC"))
const vzConnection = lazy(() => import("../containers/vzConnection/index"));
const testStartPage = lazy(() => import("../containers/testStartPage/index"));
const targetPage = lazy(() => import("../containers/testStartPage/targetPage"));
const changeApp = lazy(() => import("../containers/changeApp/index"));
const reflow = lazy(() => import("../containers/reflowTool/index"));
const NsiRequest = lazy(() => import("../containers/addressQualification/nsiRequest"));
const xpsEntry = lazy(() => import("../containers/xpsEntry/index"));
const captcha = lazy(() => import("../containers/captcha/index"));
const brtc = lazy(() => import("../containers/brtc/index"));
const ecLoopQual = lazy(() => import("../containers/change/addressQualification/index"));
const ecSmartSave = lazy(() => import("../containers/change/addressQualification/smartSave"));
const ecSmartSaveEmail = lazy(() => import("../containers/change/addressQualification/smartSaveEmail"));
const ecPendingOrder = lazy(() => import("../containers/change/addressQualification/pendingOrder"));
const ecBuildProduct = lazy(() => import("../containers/change/buildProduct/index"));
const ecHelp = lazy(() => import("../containers/change/addressQualification/help"));
const ecSignIn = lazy(() => import("../containers/change/validateSignIn/index"));
const ecSignInCoupon = lazy(() => import("../containers/change/addressQualification/signInCoupon"));
const ecCheckout = lazy(() => import("../containers/change/checkout/index"));
const ecLbo = lazy(() => import("../containers/change/lbo/index"));
const lbohoa = lazy(() => import("../containers/change/lbo/index"));
const VacationSuspend = lazy(()=>import("../containers/change/vacation/suspend/index"))
const VacationRestore = lazy(()=>import("../containers/change/vacation/restore/index"))
const intermediary = lazy(() => import("../containers/intermediary/index"));


const ecSubmitOrder = lazy(() => import("../containers/change/submitOrder"));
const ecFutureNotification = lazy(() => import("../components/futureNotification"));
const ecMoveLanding = lazy(() => import("../containers/change/move/index"));
const ecTileComp = lazy(() => import("../containers/change/samplePage/tileComp"));
const ecVzConnection = lazy(() => import("../containers/change/vzConnection/index"));
const ecTestStartPage = lazy(() => import("../containers/change/testStartPage/index"));
const ecAccountAccess = lazy(() => import("../containers/change/accountAccess/index"));
const ecXpsEntry = lazy(() => import("../containers/change/xpsEntry/index"));
const ecCaptcha = lazy(() => import("../containers/change/captcha/index"));
const movesignIn = lazy(() => import("../containers/addressQualification/MoveSignin"));
const moveStart = lazy(() => import("../containers/addressQualification/MoveStart"));
const getOrderDetail = lazy(() => import("../containers/supp/index"));
const getMoveOrderDetail = lazy(() => import("../containers/move/getMoveOrderDetail"));
const tools = lazy(() => import("../containers/tools/index"));
const tvRecommender = lazy(() => import("../containers/change/tvRecommender/index"));
const disconnect = lazy(() => import("../containers/change/disconnect/index"));
const pega = lazy(() => import("../containers/change/pega/index"));
const pegaBundlePlans = lazy(() => import("../containers/change/pega/bundleplans"));
const pegaBundleDetails = lazy(() => import("../containers/change/pega/bundledetails"));
const pegaInstallation = lazy(() => import("../containers/change/pega/installation"));
const pegaReview = lazy(() => import("../containers/change/pega/review"));
const PegaPremiumChannels = lazy(()=>import("../containers/change/pega/pegaPremiumChannels"))
const pegaConfirmation = lazy(() => import("../containers/change/pega/confirmation"));
const testDriveRecommendation = lazy(() => import('../containers/change/tvRecommender/recommendationTool/recommendationPlan'));
const testDriveRecommDetail = lazy(() => import('../containers/change/tvRecommender/recommendationTool/planDetails'));
const testDrivePremChannel = lazy(() => import('../containers/change/tvRecommender/recommendationTool/PremiumChannels'));
const testDriveReviewOrder = lazy(() => import('../containers/change/tvRecommender/recommendationTool/reviewOrder'));
const testDriveSwitchPkg = lazy(() => import('../containers/change/tvRecommender/recommendationTool/switchPackage'));
const testDriveOrderSummary = lazy(() => import('../containers/change/tvRecommender/recommendationTool/recommendationSummary'));
const ecRouterConfirmation = lazy(() => import('../containers/change/routerConfirmation/index'));
const LegacyToVMSConfirmation = lazy(()=>import('../containers/change/legacyToVmsConfirmation/index'))
const PegaRecommendation = lazy(()=>import('../containers/change/pegaRecommendation/index'))
const test = lazy(()=>import('../containers/change/test/index'))
const addressSuspend = lazy(()=>import("../containers/change/vacation/suspend/addressPage"))
const fccLearn = lazy(()=>import("../containers/buildProduct/fccLearn"))
const fiosRetailTablet = lazy(()=>import("../containers/fiosRetailTablet/index"))
const channelLineUP = lazy(() => import("../containers/channelLineUp"));
const orderSum = lazy(()=>import("../containers/buildProduct/orderSum"))
const orderSumRskn = lazy(()=>import("../containers/orderSummary/index"))
const fiosMnh = lazy(()=>import("../containers/buildProduct/fiosMnh"))
const fiosSmb = lazy(()=>import("../containers/fiosSmb/index"))

const Wrapper = window?.sessionStorage?.getItem("fiosReferralFlow") === "true" ? ErrorBoundary : React.Fragment;

const routes = (<React.Fragment>
    <Wrapper>
        <Suspense fallback={window.sessionStorage.getItem("fiosReferralFlow") === "true" ? <div className="page-overlay active" >
            <div className="section-overlay">
                <div className="row section-loader vert-middle margin-vert-zero fluid-grid">
                    <div className="column padding-vert-zero section-overlay-column">
                        <div className="margin-top-small text-medium bold" role="alert" aria-live="assertive">
                            <div className="spin-loader">
                            </div>
                            <div className="loader-messgae">
                                Loading...
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> : <div>Loading...</div>}>
    <Switch>
        <Route exact path="/inhome/qualification" component={loopQualWidget} />
        <Route path="/inhome/lq1qualification" component={loopQual} />
        <Route path="/inhome/intermediary" component={intermediary} />
        <Route path="/inhome/checkavailability" component={loopQualWidget}/>
        {!isProductionEnvironment && <Route path="/inhome/push/segment" component={segment} /> }      
        {!isProductionEnvironment && <Route path="/inhome/push/campaign" component={campaign} />}
        <Route path="/inhome/captcha" component={captcha} />
        <Route path="/inhome/help" component={help} />
        <Route path="/inhome/savecart" component={smartSave} />
        <Route path="/inhome/sendcart" component={smartSaveEmail} />
        <Route path="/inhome/pendingorder" component={pendingOrder} />
        <Route path="/inhome/signinmh" component={signInMH} />
        <Route path="/inhome/nonfiosredirect" component={nonfiosRedirect} />
        <Route path="/inhome/twsdiscount" component={mfrtVendor} />
        <Route path="/inhome/15g" component={fifteng} />
        {/* <Route path="/inhome/buildproductsRskn" component={buildProductReskin} /> */}
        <Route path="/inhome/buildproducts" component={buildProductReskin} />
        {/* Streamline MLP Plans Page */}
        <Route path="/inhome/streamlineordering" component={streamlineOrdering} />
        <Route path="/inhome/streamlinetvvoice" component={streamlineTVPhoneOrdering} />
        <Route path="/inhome/popularPlans" component={popularPlans}/>
        <Route path="/inhome/signin" component={signIn} />
        <Route path="/inhome/employee" component={signInCoupon} />
        <Route path="/inhome/checkout" component={checkout} />
        <Route path="/inhome/summary" component={submitOrder} />
        <Route path="/inhome/lbo" component={lbo} />
        <Route path="/inhome/futurenotification" component={futureNotification} />
        <Route path="/inhome/nsinotification" component={nsiNotification} />
        <Route path="/inhome/nsiNYC" component={nsiNYC} />
        <Route path="/inhome/nsirequest" component={NsiRequest} />
        <Route path="/inhome/connection" component={vzConnection} />
        <Route path="/inhome/tile" component={tileComp} />
        {!isProductionEnvironment && <Route path="/inhome/teststartpage" component={testStartPage} />}
        <Route path="/inhome/targetpage" component={targetPage} />
        <Route path="/inhome/changeApp" component={changeApp} />
        {!isProductionEnvironment && <Route path="/inhome/reflowtool" component={reflow} />}
        <Route path="/inhome/change/accountaccess" component={ecAccountAccess} />
        <Route path="/inhome/resumecart" component={xpsEntry} />
        <Route path="/inhome/brtc" component={brtc} />
        {/* //URC Change */}
        <Route path="/inhome/change/qualification" component={ecLoopQual} />
        <Route path="/inhome/change/captcha" component={ecCaptcha} />
        <Route path="/inhome/change/help" component={ecHelp} />
        <Route path="/inhome/change/savecart" component={ecSmartSave} />
        <Route path="/inhome/change/sendcart" component={ecSmartSaveEmail} />
        <Route path="/inhome/change/pendingorder" component={ecPendingOrder} />
        <Route path="/inhome/change/buildproducts" component={ecBuildProduct} />
        <Route path="/inhome/change/tvrecommender" component={tvRecommender} />
        <Route path="/inhome/change/disconnect" component={disconnect} />
        <Route path="/inhome/change/recommendation/plan" component={testDriveRecommendation} />
        <Route path="/inhome/change/recommendation/detail" component={testDriveRecommDetail} />
        <Route path="/inhome/change/recommendation/premiumchannel" component={testDrivePremChannel} />
        <Route path="/inhome/change/recommendation/order" component={testDriveReviewOrder} />
        <Route path="/inhome/change/recommendation/switchpackage" component={testDriveSwitchPkg} />  
        <Route path="/inhome/change/recommendation/orderSummary" component={testDriveOrderSummary} />       
        <Route path="/inhome/change/signin" component={ecSignIn} />
        <Route path="/inhome/change/employee" component={ecSignInCoupon} />
        <Route path="/inhome/change/checkout" component={ecCheckout} />
        <Route path="/inhome/change/summary" component={ecSubmitOrder} />
        <Route path="/inhome/change/lbo" component={ecLbo} />
        <Route path="/inhome/change/lbo-hoa" component={lbohoa} />
        <Route path="/inhome/change/futurenotification" component={ecFutureNotification} />
        <Route path="/inhome/change/moves" component={ecMoveLanding} />
        <Route path="/inhome/change/connection" component={ecVzConnection} />
        <Route path="/inhome/change/tile" component={ecTileComp} />
        {!isProductionEnvironment && <Route path="/inhome/change/teststartpage" component={ecTestStartPage} />}
        <Route path="/inhome/change/resumecart" component={ecXpsEntry} />
        <Route path="/inhome/change/suspendservices" component={VacationSuspend}/>
        <Route path="/inhome/change/restoreservices" component={VacationRestore}/>
        <Route path="/inhome/change/suspendservicesAddress" component={addressSuspend}/>
        <Route path="/inhome/change/routerConfirmation" component={ecRouterConfirmation}/>
        <Route exact path="/inhome/change/LegacyToVMSConfirmation" component={LegacyToVMSConfirmation}/>
        <Route exact path="/inhome/change/pegarecommendation" component={PegaRecommendation}/>
        <Route exact path="/inhome/change/test" component={test}/> 


        

        {/* //End URC Change */}
        {/* //Pega Change */}
        <Route path="/inhome/change/pega/renewalBundlePlans" component={pegaBundlePlans} />
        <Route path="/inhome/change/pega/bundleDetails" component={pegaBundleDetails} />
        <Route path="/inhome/change/pega/installation" component={pegaInstallation} />
        <Route path="/inhome/change/pega/review" component={pegaReview} />
        <Route path="/inhome/change/pega/pegaPremiumChannels" component={PegaPremiumChannels}/>
        <Route path="/inhome/change/pega/confirmation" component={pegaConfirmation} />
        {/* //end Pega Change */}

        {/* //move Change */}
        {!isProductionEnvironment && <Route path="/inhome/movestart" component={moveStart} /> }
        <Route path="/inhome/moves/movesignIn" component={movesignIn} />        
        <Route path="/inhome/movesignIn" component={movesignIn} /> 
        <Route exact path="/inhome/moves/qualification" component={loopQualWidget} /> 
        <Route exact path="/inhome/moves/lq1qualification" component={loopQual} />
        <Route exact path="/inhome/moves/checkavailability" component={loopQualWidget} />
        <Route path="/inhome/moves/landing" component={moveLandingReskin} />
        {/* <Route path="/inhome/moves/landingRskn" component={moveLandingReskin} /> */}
        <Route path="/inhome/landing" component={loopQual} />
        <Route path="/inhome/moves/buildproducts" component={buildProductReskin} />
        {/* <Route path="/inhome/moves/buildproductsRskn" component={buildProductReskin} /> */}
        <Route path="/inhome/moves/ordersummary" component={orderSumRskn} />
        <Route path="/inhome/moves/checkout" component={checkout} />
        <Route path="/inhome/moves/summary" component={submitOrder} />
        <Route path="/inhome/moves/help" component={help} />
        <Route path="/inhome/moves/pendingorder" component={pendingOrder} />
        <Route path="/inhome/moves/lbo" component={lbo} />
        <Route path="/inhome/moves/futurenotification" component={futureNotification} />
        <Route path="/inhome/moves/nsinotification" component={nsiNotification} />
        <Route path="/inhome/moves/nsirequest" component={NsiRequest} />
        <Route path="/inhome/moves/connection" component={vzConnection} />
        <Route path="/inhome/moves/savecart" component={smartSave} />
        <Route path="/inhome/moves/twsdiscount" component={mfrtVendor} />
        <Route path="/inhome/moves/nonfiosredirect" component={nonfiosRedirect} />
        <Route path="/inhome/moves/getmoveorderdetail" component={getMoveOrderDetail}/>
{/* fcclearnpage */}
        <Route path="/inhome/fccbroadbandlabels" component={fccLearn}/>
        <Route path="/inhome/ordersummary" component={orderSumRskn}/>
        <Route path="/inhome/ordersummaryRskn" component={orderSumRskn}/>
        <Route path="/inhome/fiosreferral" component={fiosRetailTablet}/>

        {/* //move Change End */}
        <Route path="/inhome/change/fiosmnh" component={fiosMnh} />

        <Route path="/inhome/decrypttool" component={tools} />
        <Route path="/inhome/change/supp/getorderdetail" component={getOrderDetail}/>       
        <Route path="/inhome/change/supp/buildproducts" component={buildProduct} />
        <Route path="/inhome/change/supp/checkout" component={checkout} />
        <Route path="/inhome/change/supp/summary" component={submitOrder} />
        <Route path="/inhome/change/supp/lbo" component={lbo} />
        {/* smb fios */}
        <Route path="/inhome/smb" component={fiosSmb} />
        {/* channel line up */}
        <Route path="/inhome/fiostv/channellineup" component={channelLineUP} />
        <Route path="*" component={custError} />
        
    </Switch>
    </Suspense>
    </Wrapper>
</React.Fragment>
)
export default routes
